import React, { useEffect, useState, useCallback } from 'react';
import { favoriteService } from '../api';
import AdCard from './AdCard';
import './AdCard.css';
import './FavoritesList.css';

const FavoritesList = () => {
    const [ads, setAds] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const load = useCallback(() => {
        setLoading(true);
        setError(null);
        favoriteService.getFavorites()
            .then(({ data }) => setAds(data))
            .catch(() => setError('Не удалось загрузить избранное.'))
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => { load(); }, [load]);

    if (loading) return <div className="profile-content__placeholder">Загрузка...</div>;
    if (error) return <div className="profile-content__placeholder">{error}</div>;
    if (ads.length === 0) return <div className="profile-content__placeholder">Вы пока ничего не добавили в избранное.</div>;

    return (
        <div className="favorites-grid">
            {ads.map(ad => (
                <AdCard
                    key={ad.id}
                    ad={ad}
                    view="grid"
                    onFavoriteChange={(adId, isFavorite) => {
                        if (!isFavorite) setAds(prev => prev.filter(a => a.id !== adId));
                    }}
                />
            ))}
        </div>
    );
};

export default FavoritesList;
